import axios from "axios";
import { Axios, baseUrl } from "../../Services/Axios/index";

export const fetchAreas = async () => {
  return await Axios.get("/store/laundry-areas/get-areas", {
    responseType: "json",
  });
};
export const addAddress = async (payload) => {
  const token = localStorage.getItem("token");
  return axios.post("/api/store/customer/address/add", payload, {
    responseType: "json",
    baseURL: baseUrl,
    headers: {
      moduleid: "",
      storeType: "laundry",
      Laundryzoneid: payload.laundryZoneId,
      Zoneid: payload.zoneId,
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateAddress = async (payload) => {
  const token = localStorage.getItem("token");
  return axios.put(
    `/api/store/customer/address/update/${payload.id}`,
    payload,
    {
      responseType: "json",
      baseURL: baseUrl,
      headers: {
        moduleid: "",
        storeType: "laundry",
        Laundryzoneid: payload.laundryZoneId,
        Zoneid: payload.zoneId,
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
// export const fetchAddresses = async () => {
//   const user_id = localStorage.getItem("customerId");
//   return await Axios.get(`/store/customer/address/list/?user_id=${user_id}`, {
//     responseType: "json",
//   });
// };
export const fetchAddresses = async () => {
  const user_id = localStorage.getItem("customerId");
  return await Axios.get(`/store/customer/address/list?user_id=${user_id}`, {
    responseType: "json",
  });
};
export const deleteAddress = async (addressId, user_id) => {
  return await Axios.delete(
    `/store/customer/address/delete?address_id=${addressId}&user_id=${user_id}`,
    { responseType: "json" }
  );
};
